import React, { useState, useEffect } from 'react';
import { View, Text, Pressable } from '../lib/react-native-compat';
import { useAtom } from 'jotai';
import { selectedJobAtom, selectedVersionAtom, isLiveVersionAtom, jobUserDataAtom, userIdAtom } from '../store/company';
import { loadUserData } from '../db/company';
import COLog from './colog';
import COLogUpload from './cologUpload';
import COLogPSRView from './cologPSRView';
import COLogEntry from './cologEntry';
import COLogEntryClassic from './cologEntryClassic';
import COLogMigrationStatus from './cologMigrationStatus';

const CoLogOverview = () => {
    const [activeTab, setActiveTab] = useState('CO Log');
    const [selectedJob] = useAtom(selectedJobAtom);
    const [selectedVersion] = useAtom(selectedVersionAtom);
    const [isLiveVersion] = useAtom(isLiveVersionAtom);
    const [jobUserData, setJobUserData] = useAtom(jobUserDataAtom);
    const [userId] = useAtom(userIdAtom);
    const tabs = userId === '154045'
        ? ['CO Log', 'PSR View', 'Old Format', 'Migration Status']
        : ['CO Log', 'PSR View'];

    useEffect(() => {
        if (selectedJob && selectedVersion) {
            loadUserData({ id: selectedJob, forecastGuid: selectedVersion, live: isLiveVersion }).then((data) => {
                setJobUserData(data?.data);
            })
        }
    }, [selectedJob, selectedVersion, isLiveVersion]);

    return (
        <View style={{ flex: 1, backgroundColor: '#fff' }}>
            {/* Tab Navigation */}
            <View style={{ 
                backgroundColor: '#ffffff', 
                borderBottom: '1px solid #e2e8f0',
                paddingLeft: 20,
                paddingTop: 8
            }}>
                <View style={{ flexDirection: 'row', gap: 20, marginLeft: 10, height: 42 }}>
                    {tabs.map((tab) => (
                        <Pressable
                            key={tab}
                            onPress={() => setActiveTab(tab)}
                            style={{
                                paddingVertical: 12,
                                paddingHorizontal: 16,
                                borderBottom: activeTab === tab ? '2px solid #2563eb' : '2px solid transparent',
                                backgroundColor: 'transparent',
                                justifyContent: 'center',
                            }}
                        >
                            <Text style={{
                                fontSize: 14,
                                color: activeTab === tab ? '#111827' : '#6b7280',
                                fontWeight: activeTab === tab ? '600' : '400',
                            }}>
                                {tab}
                            </Text>
                        </Pressable>
                    ))}
                </View>
            </View>

            {/* Tab Content */}
            <View style={{ flex: 1, backgroundColor: '#fff' }}>
                {activeTab === 'Upload' ? <COLogUpload /> : null}
                {activeTab === 'CO Log' ? <COLogEntry /> : null}
                {activeTab === 'Classic' ? <COLogEntryClassic /> : null}
                {activeTab === 'PSR View' ? <COLogPSRView /> : null}
                {activeTab === 'Old Format' ? <COLog /> : null}
                {activeTab === 'Migration Status' ? <COLogMigrationStatus /> : null}
            </View>
        </View>
    );
};

export default CoLogOverview;